import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommerceEmailsListAction from '../actions/ecommerce-emails-list.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadEcommerceEmailsList} from "../actions";
import {EcommerceService} from "../../websites/website/ecommerce/ecommerce.service";
import {
  EmailsListMapper
} from "../../websites/website/ecommerce/ecommerce-emails/emails-list-table/mapper/emails-list-mapper";

@Injectable()
export class EcommerceEmailsListEffect {

  loadEcommerceEmailsList = createEffect(() => this._actions$.pipe(
    ofType(EcommerceEmailsListAction.LOAD_ECOMMERCE_EMAILS_LIST),
    mergeMap((action: LoadEcommerceEmailsList) => {
      const {websiteId} = action.payload;
      return this._ecommerceService.getEmailsList(websiteId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response?.data) {
              const data = response?.data;
              const emailsList = Object.keys(data).map((key) => EmailsListMapper.map(data[key]));
              return new EcommerceEmailsListAction.LoadEcommerceEmailsListSuccess({
                data: emailsList,
                websiteId: websiteId,
                loaded: true
              });
            }
            return new EcommerceEmailsListAction.LoadEcommerceEmailsListFail({websiteId});
          })
        );
    })
  ));



  constructor(
    private _actions$: Actions,
    private _ecommerceService: EcommerceService,
  ) {
  }

}
